import {useEffect, useState} from "react";
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';
import dayjs from 'dayjs';
import glConfig from "@configs/glConfig";
import {DateFormat} from "@public/Global";
import { t, getLang } from "@/locales";

export default function headerState() {
    const [lang, setLang] = useState(getLang());

    useEffect(() => {
        const handleChange = () => setLang(getLang());
        window.addEventListener('langChange', handleChange);
        return () => window.removeEventListener('langChange', handleChange);
    }, []);

    const navs=[
        {name: t('header.about'), route: "/"},
        {name: t('header.rental'), link:'https://68a36b52.app.doorloop.com/tenant-portal/rental-applications/listing?companyId=6797e489ce80b940fec1465d&source=CompanyLink'},
        {name: t('header.findAgent'), route: "/employee"},
        {name: t('header.becomeAgent'), route: "/agent"},
        {name: t('header.login'), link:"https://68a36b52.app.doorloop.com/auth/login", isButton:true}
    ];
    const [menuOpen, setMenuOpen]=useState(false);
    return {
        navs,menuOpen, setMenuOpen
    }
}
